// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3306":"d8199000d2dfa49e","6258":"279581af55a159e8"}[chunkId] + ".css";
};